export type DriverInfoFormData = {
  shift_preference: string
  preferred_template: string
  shift_start_time: Date | moment.Moment
  shift_length_hours: number
  active: boolean
  status: string
  name: string
  username: string
  title: string
  hire_date: string
  supervisor: string
  in_cab_trip_mode: string
  auto_schedule: boolean
  tractor_number: string | null
  trailer_number: string | null
  source_id: string
  source_system_id: string
  work_email: string
  depot: string
  in_cab_supply_option_mode: (typeof SupplyOptionModes)[keyof typeof SupplyOptionModes]
}

export const InCabTripModes = {
  restricted: 'restricted',
  current: 'current',
  all: 'all',
  allAndNext: 'all and next',
} as const

export const SupplyOptionModes = {
  terminal: 'terminal',
  orderStart: 'order_start',
  disabled: 'disabled',
  terminalAndOrderStart: 'terminal_and_order_start',
} as const
